import {
  CURRICULUM_TYPE_DP,
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_PYP,
  CURRICULUM_TYPE_UBD,
  ELEMENT_TYPE_PYP_LEARNING_STANDARD,
  ELEMENT_TYPE_DP_LEARNING_STANDARD,
  ELEMENT_TYPE_MYP_LEARNING_STANDARD,
  ELEMENT_TYPE_UBD_LEARNING_STANDARD,
  ELEMENT_TYPE_DP_SUBJECT,
  ELEMENT_TYPE_MYP_SUBJECT,
  ELEMENT_TYPE_PYP_SUBJECT,
  ELEMENT_TYPE_UBD_SUBJECT,
  ELEMENT_TYPE_PYP_ATL,
  ELEMENT_TYPE_PYP_KEY_CONCEPT,
  ELEMENT_TYPE_PYP_LEARNER_PROFILE,
  ELEMENT_TYPE_MYP_ATL,
  ELEMENT_TYPE_MYP_LEARNER_PROFILE,
  ELEMENT_TYPE_UBD_ATL,
  ELEMENT_TYPE_DP_ATL,
  ELEMENT_TYPE_DP_LEARNER_PROFILE,
  ELEMENT_TYPE_DP_OBJECTIVES,
  ELEMENT_TYPE_MYP_OBJECTIVES,
  ELEMENT_TYPE_UNIT_PLAN,
  ELEMENT_TYPE_DP_TOK,
  ELEMENT_TYPE_DP_EXTENDED_ESSAY,
  ELEMENT_TYPE_DP_CAS_LEARNING_OUTCOMES,
  ELEMENT_TYPE_DP_CAS,
} from "Constants/stringConstants";

export const TERM_TOTAL_COLUMNS = "TERM_TOTAL_COLUMNS";
export const CATEGORY_COLUMNS = "CATEGORY_COLUMNS";
export const ASSESSMENT_COLUMNS = "ASSESSMENT_COLUMNS";

export const TERM_ROOT_HEADER = "TERM_ROOT_HEADER";
export const TERM_TOTAL_HEADER = "TERM_TOTAL_HEADER";
export const TERM_SUB_HEADERS = "TERM_SUB_HEADERS";
export const TERM_CRITERIA_GRADE_SCALE_HEADERS =
  "TERM_CRITERIA_GRADE_SCALE_HEADERS";
export const CATEGORY_ROOT_HEADER = "CATEGORY_ROOT_HEADER";
export const CATEGORY_TOTAL_HEADER = "CATEGORY_TOTAL_HEADER";
export const CATEGORY_SUB_HEADERS = "CATEGORY_SUB_HEADERS";
export const ASSIGNMENT_HEADERS = "ASSIGNMENT_HEADERS";
export const ASSIGNMENT_EVALUATION_HEADERS = "ASSIGNMENT_EVALUATION_HEADERS";
export const ASSESSMENT_TOOL_HEADERS = "ASSESSMENT_TOOL_HEADERS";

export const STUDENTS = "STUDENTS";
export const CATEGORY_TOTAL = "CATEGORY_TOTAL";
export const CRITERION_A = "CRITERION_A";
export const CRITERION_B = "CRITERION_B";
export const CRITERION_C = "CRITERION_C";
export const CRITERION_D = "CRITERION_D";
export const CRITERIA_TOTAL = "CRITERIA_TOTAL";
export const MYP_CRITERIA_FINAL_SCORE = "MYP_CRITERIA_FINAL_SCORE";
export const IB_DEFINED = "IB_DEFINED";
export const SUBJECT_DESCRIPTION = "SUBJECT_DESCRIPTION";
export const FINAL_COMMENT = "FINAL_COMMENT";
export const CRITERION_A_COMMENT = "CRITERION_A_COMMENT";
export const CRITERION_B_COMMENT = "CRITERION_B_COMMENT";
export const CRITERION_C_COMMENT = "CRITERION_C_COMMENT";
export const CRITERION_D_COMMENT = "CRITERION_D_COMMENT";
export const CRITERION_A_GRADE_SCALE = "CRITERION_A_GRADE_SCALE";
export const CRITERION_B_GRADE_SCALE = "CRITERION_B_GRADE_SCALE";
export const CRITERION_C_GRADE_SCALE = "CRITERION_C_GRADE_SCALE";
export const CRITERION_D_GRADE_SCALE = "CRITERION_D_GRADE_SCALE";
export const CATEGORY_GRADE_SCALE = "CATEGORY_GRADE_SCALE";

export const BULK_EVALUATION = "BULK_EVALUATION";
export const BULK_GRADE = "BULK_GRADE";

// * view by
export const CATEGORY = "CATEGORY";
export const ASSIGNMENT = "ASSIGNMENT";

// * order by
export const DISPLAY_SEQUENCE = "DISPLAY_SEQUENCE";
export const CREATED_AT = "CREATED_AT";
export const DUE_AT = "DUE_AT";
export const TITLE = "TITLE";
export const PUBLISHED_AT = "PUBLISHED_AT";

export const TERM_LEVEL_CRITERION_COLUMNS = [
  CRITERION_A,
  CRITERION_B,
  CRITERION_C,
  CRITERION_D,
];

export const TERM_LEVEL_CRITERION_GRADE_SCALE_COLUMNS = [
  CRITERION_A_GRADE_SCALE,
  CRITERION_B_GRADE_SCALE,
  CRITERION_C_GRADE_SCALE,
  CRITERION_D_GRADE_SCALE,
];

export const TERM_LEVEL_CRITERION_COMMENTS_COLUMNS = [
  CRITERION_A_COMMENT,
  CRITERION_B_COMMENT,
  CRITERION_C_COMMENT,
  CRITERION_D_COMMENT,
];

export const ASSIGNMENT_CRITERION_A = "ASSIGNMENT_CRITERION_A";
export const ASSIGNMENT_CRITERION_B = "ASSIGNMENT_CRITERION_B";
export const ASSIGNMENT_CRITERION_C = "ASSIGNMENT_CRITERION_C";
export const ASSIGNMENT_CRITERION_D = "ASSIGNMENT_CRITERION_D";

// * datagrid context menu options keys
export const CONFIGURE_GRADEBOOK_VIEWS = "configure_gradebook_views";
export const GRADING_SETUP = "grading_setup";
export const MYP_CRITERIA_CONFIGURATION = "myp_criteria_configuration";
// export const ACTIVITY_LOG = "activity_log";
export const DOWNLOAD = "download";

export const GRADEBOOK_ROUTES = {
  assessmentObjectives: "assessment-objectives",
  subjectsStandards: "subjects-standards",
  atls: "atls",
  lpas: "lpas",
  learnerProfile: "learner-profile",
  keyConcepts: "key-concepts",
  assessments: "assessments",
};

export const SUBJECT_LEVEL_SORT_ORDER = ["SL", "HL"];

// * explicitly defined colors mapping for the learning goals criteria values for better visibility on screen
// * textColor and backgroundColor used for datagrid cells
// * textColor2 used for grading history
export const GRADE_SCALE_VALUES_COLORS_MAP = {
  "#dab1f0": {
    textColor: "#832dad",
    textColor2: "#b646ee",
    backgroundColor: "#faf1fe",
    defaultColor: "#dab1f0",
  },
  "#c5c5fc": {
    textColor: "#4242c3",
    textColor2: "#6262f5",
    backgroundColor: "#f3f3ff",
    defaultColor: "#c5c5fc",
  },
  "#ffaec0": {
    textColor: "#a61c58",
    textColor2: "#f04f7b",
    backgroundColor: "#fff0f6",
    defaultColor: "#ffaec0",
  },
  "#ffce66": {
    textColor: "#954300",
    textColor2: "#d67900",
    backgroundColor: "#fff8e5",
    defaultColor: "#ffce66",
  },
  "#bde26c": {
    textColor: "#3e6100",
    textColor2: "#6d9c00",
    backgroundColor: "#f4f9e7",
    defaultColor: "#bde26c",
  },
  "#ffad71": {
    textColor: "#9f3c19",
    textColor2: "#e8653a",
    backgroundColor: "#fff2ee",
    defaultColor: "#ffad71",
  },
  "#75ddc3": {
    textColor: "#00644d",
    textColor2: "#00a181",
    backgroundColor: "#e6faf6",
    defaultColor: "#75ddc3",
  },
  "#6bdeef": {
    textColor: "#00616e",
    textColor2: "#009cad",
    backgroundColor: "#e5fbfd",
    defaultColor: "#6bdeef",
  },
  "#f75961": {
    textColor: "#a61c58",
    textColor2: "#f04f7b",
    backgroundColor: "#fff0f6",
    defaultColor: "#f75961",
  },
  "#9f49cc": {
    textColor: "#832dad",
    textColor2: "#b646ee",
    backgroundColor: "#faf1fe",
    defaultColor: "#9f49cc",
  },
  "#6464dc": {
    textColor: "#4242c3",
    textColor2: "#6262f5",
    backgroundColor: "#f3f3ff",
    defaultColor: "#6464dc",
  },
  "#f76e88": {
    textColor: "#a61c58",
    textColor2: "#f04f7b",
    backgroundColor: "#fff0f6",
    defaultColor: "#f76e88",
  },
  "#ffab00": {
    textColor: "#954300",
    textColor2: "#d67900",
    backgroundColor: "#fff8e5",
    defaultColor: "#ffab00",
  },
  "#8bc216": {
    textColor: "#3e6100",
    textColor2: "#6d9c00",
    backgroundColor: "#f4f9e7",
    defaultColor: "#8bc216",
  },
  "#ff7712": {
    textColor: "#9f3c19",
    textColor2: "#e8653a",
    backgroundColor: "#fff2ee",
    defaultColor: "#ff7712",
  },
  "#2eaa8b": {
    textColor: "#00644d",
    textColor2: "#00a181",
    backgroundColor: "#e6faf6",
    defaultColor: "#2eaa8b",
  },
  "#05b2c7": {
    textColor: "#00616e",
    textColor2: "#009cad",
    backgroundColor: "#e5fbfd",
    defaultColor: "#05b2c7",
  },
  "#af273e": {
    textColor: "#a61c58",
    textColor2: "#f04f7b",
    backgroundColor: "#fff0f6",
    defaultColor: "#af273e",
  },
  "#704d00": {
    textColor: "#954300",
    textColor2: "#d67900",
    backgroundColor: "#fff8e5",
    defaultColor: "#704d00",
  },
  "#7feaf6": {
    textColor: "#00616e",
    textColor2: "#009cad",
    backgroundColor: "#e5fbfd",
    defaultColor: "#7feaf6",
  },
  "#00c4db": {
    textColor: "#00616e",
    textColor2: "#009cad",
    backgroundColor: "#e5fbfd",
    defaultColor: "#00c4db",
  },
  "#ffb5c9": {
    textColor: "#a61c58",
    textColor2: "#f04f7b",
    backgroundColor: "#fff0f6",
    defaultColor: "#ffb5c9",
  },
  "#ff668f": {
    textColor: "#a61c58",
    textColor2: "#f04f7b",
    backgroundColor: "#fff0f6",
    defaultColor: "#ff668f",
  },
  "#8a064c": {
    textColor: "#a61c58",
    textColor2: "#f04f7b",
    backgroundColor: "#fff0f6",
    defaultColor: "#8a064c",
  },
  "#c3c3ff": {
    textColor: "#4242c3",
    textColor2: "#6262f5",
    backgroundColor: "#f3f3ff",
    defaultColor: "#c3c3ff",
  },
  "#7777ff": {
    textColor: "#4242c3",
    textColor2: "#6262f5",
    backgroundColor: "#f3f3ff",
    defaultColor: "#7777ff",
  },
  "#82e8d3": {
    textColor: "#00644d",
    textColor2: "#00a181",
    backgroundColor: "#e6faf6",
    defaultColor: "#82e8d3",
  },
  "#00b993": {
    textColor: "#00644d",
    textColor2: "#00a181",
    backgroundColor: "#e6faf6",
    defaultColor: "#00b993",
  },
  "#ffdb7f": {
    textColor: "#954300",
    textColor2: "#d67900",
    backgroundColor: "#fff8e5",
    defaultColor: "#ffdb7f",
  },
  "#ffaa00": {
    textColor: "#954300",
    textColor2: "#d67900",
    backgroundColor: "#fff8e5",
    defaultColor: "#ffaa00",
  },
  "#b35a00": {
    textColor: "#954300",
    textColor2: "#d67900",
    backgroundColor: "#fff8e5",
    defaultColor: "#b35a00",
  },
  "#e6e6e6": {
    textColor: "#525252",
    textColor2: "#8f8f8f",
    backgroundColor: "#fafafa",
    defaultColor: "#e6e6e6",
  },
  "#adadad": {
    textColor: "#525252",
    textColor2: "#8f8f8f",
    backgroundColor: "#fafafa",
    defaultColor: "#adadad",
  },
  "#ffc2ae": {
    textColor: "#9f3c19",
    textColor2: "#e8653a",
    backgroundColor: "#fff2ee",
    defaultColor: "#ffc2ae",
  },
  "#ff865d": {
    textColor: "#9f3c19",
    textColor2: "#e8653a",
    backgroundColor: "#fff2ee",
    defaultColor: "#ff865d",
  },
  "#e7b9fe": {
    textColor: "#832dad",
    textColor2: "#b646ee",
    backgroundColor: "#faf1fe",
    defaultColor: "#e7b9fe",
  },
  "#cc66ff": {
    textColor: "#832dad",
    textColor2: "#b646ee",
    backgroundColor: "#faf1fe",
    defaultColor: "#cc66ff",
  },
  "#c8e487": {
    textColor: "#3e6100",
    textColor2: "#6d9c00",
    backgroundColor: "#f4f9e7",
    defaultColor: "#c8e487",
  },
  "#8ec80a": {
    textColor: "#3e6100",
    textColor2: "#6d9c00",
    backgroundColor: "#f4f9e7",
    defaultColor: "#8ec80a",
  },
  "#ff6169": {
    textColor: "#ad1d22",
    textColor2: "#f04c54",
    backgroundColor: "#ffefef",
    defaultColor: "#ff6169",
  },
  "#ffb2b6": {
    textColor: "#ad1d22",
    textColor2: "#f04c54",
    backgroundColor: "#ffefef",
    defaultColor: "#ffb2b6",
  },
};

// * gradebook types
export const ASSESSMENTS_GRADEBOOK = "ASSESSMENTS_GRADEBOOK";
export const LEARNING_GOALS_GRADEBOOK = "LEARNING_GOALS_GRADEBOOK";
export const STANDARDS_GRADEBOOK = "STANDARDS_GRADEBOOK";
export const FINAL_GRADES_GRADEBOOK = "FINAL_GRADES_GRADEBOOK";

export const SUBJECT_TYPE_BY_CURRICULUM = {
  [CURRICULUM_TYPE_PYP]: ELEMENT_TYPE_PYP_SUBJECT,
  [CURRICULUM_TYPE_UBD]: ELEMENT_TYPE_UBD_SUBJECT,
  [CURRICULUM_TYPE_MYP]: ELEMENT_TYPE_MYP_SUBJECT,
  [CURRICULUM_TYPE_DP]: ELEMENT_TYPE_DP_SUBJECT,
};

export const STANDARDS_TYPES_BY_CURRICULUM = {
  [CURRICULUM_TYPE_PYP]: ELEMENT_TYPE_PYP_LEARNING_STANDARD,
  [CURRICULUM_TYPE_UBD]: ELEMENT_TYPE_UBD_LEARNING_STANDARD,
  [CURRICULUM_TYPE_MYP]: ELEMENT_TYPE_MYP_LEARNING_STANDARD,
  [CURRICULUM_TYPE_DP]: ELEMENT_TYPE_DP_LEARNING_STANDARD,
};

export const SUBJECT_COMMENTS_COLUMNS = [SUBJECT_DESCRIPTION, FINAL_COMMENT];

export const VERTICAL_GRADING_INFO_LOCALES = {
  maximumValue: "classRoom:maximumValue_rollup_method_info",
  mean: "classRoom:mean_rollup_method_info",
  bestFit: "classRoom:bestFit_rollup_method_info",
  rollupWeighting: "classRoom:rollupWeighting_rollup_method_info",
};

// * Used for new grading setup
export const LEARNING_GOALS_DATASETS_CURRICULUM_WISE = {
  [CURRICULUM_TYPE_PYP]: [
    ELEMENT_TYPE_PYP_ATL,
    ELEMENT_TYPE_PYP_KEY_CONCEPT,
    ELEMENT_TYPE_PYP_LEARNER_PROFILE,
    ELEMENT_TYPE_UNIT_PLAN,
  ],
  [CURRICULUM_TYPE_UBD]: [ELEMENT_TYPE_UBD_ATL],
  [CURRICULUM_TYPE_MYP]: [
    ELEMENT_TYPE_MYP_ATL,
    ELEMENT_TYPE_MYP_OBJECTIVES,
    ELEMENT_TYPE_MYP_LEARNER_PROFILE,
  ],
  [CURRICULUM_TYPE_DP]: [
    ELEMENT_TYPE_DP_ATL,
    ELEMENT_TYPE_DP_LEARNER_PROFILE,
    ELEMENT_TYPE_DP_OBJECTIVES,
    ELEMENT_TYPE_DP_CAS,
    ELEMENT_TYPE_DP_CAS_LEARNING_OUTCOMES,
    ELEMENT_TYPE_DP_EXTENDED_ESSAY,
    ELEMENT_TYPE_DP_TOK,
  ],
};

export const CHECKBOX_MARKER_ROW = "CHECKBOX_MARKER_ROW";

export const HTML_TO_TEXT_OPTIONS = {
  wordwrap: false,
  preserveNewlines: true,
};
